import React, { useState, useEffect } from "react";
import Banner from "../../components/Banner/Banner";
import Nav from "../../components/Nav/Nav";
import Quality from "../../components/Quality/Quality";
import About from "../../components/About/About";
import Prooducts from "../../components/Products/Prooducts";
import Contact from "../../components/Conatct/Contact";
import Footer from "../../components/Footer/Footer";
import Trust from "../../components/Trust/Trust";
import Notification from "../../components/Notification/Notification";
import Slider from "../../components/Slider/Slider";
import Shadow from "../../components/Shadow/Shadow";
import FixedIcons from "../../components/FixedIcons/FixedIcons";
import Topbar from "../../components/TopBar/Topbar";
import Eachimage from "../../components/EachImage/Eachimage";
import {motion} from 'framer-motion';
import Messanger from "../../components/Messagnger/Messanger";
import Welcome from "../../components/Welcome/Welcome";

/* New Components */
import Blog from "../../components/Blog/Blog";
import Gallery from "../../components/Gallery/Gallery";
import Stats from "../../components/Stats/Stats";
import QuoteReveal from "../../components/QuoteReveal/QuoteReveal";
import Solutions from "../../components/Solutions/Solutions";

function HomePage() {
  const [cursorX, setCursorX] = useState();
  const [cursorY, setCursorY] = useState();

  useEffect(() => {
    const handleMouseMove = (e) => {
      setCursorY(e.pageY);
      setCursorX(e.pageX);
    };
    
    window.addEventListener("mousemove", handleMouseMove);
    
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <motion.div animate={{opacity:1 }} exit={{opacity:0}} initial={{opacity:0 }} transition={{duration:0.5}} > 
      <Notification />
      <Nav />
      <Banner />
      
      {/* Existing Lower Sections Adapted into Single Page */}
      <Welcome />
      <Trust />
      
      {/* New Durable, Stylish Roofing Solutions Carousel */}
      <Solutions />

      {/* New Professional Stats Section */}
      <Stats />

      {/* New Scroll Reveal Quote Section */}
      <QuoteReveal />

      <Prooducts />

      <About />

      {/* New Professional Gallery Section */}
      <Gallery />
      
      <Contact />
      <Footer />
      <Slider />
      <Shadow />
      <Eachimage />
      <FixedIcons />
      <Messanger />
      
      <div
        style={{ left: cursorX + "px", top: cursorY + "px" }}
        className="curosr"
      ></div>
    </motion.div>
  );
}

export default HomePage;
